import styles from './EvervaultBackground.module.css';
import {useEffect, useState, useRef, useCallback} from 'react';

/**
 * 
 * @param {{fontSize: number}}
 * @returns 
 */
function EvervaultBackground({numCharsMult = 1}) {
  const [letters, setLetters] = useState();

  const eRef = useRef(null)

  
  const makeLetters = useCallback(() => {
    const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const randomChar = () => chars[Math.floor(Math.random() * (chars.length - 1))]
    const randomString = length => Array.from(Array(length)).map(randomChar).join("")
    const charsCount = Math.floor(Math.max(eRef.current.clientWidth * eRef.current.clientHeight * 0.01 * numCharsMult, 0))
    setLetters(randomString(charsCount))
  }, [numCharsMult])

  const handleOnMove = e => {
    makeLetters()
  }

  useEffect(() => {
    window.addEventListener('resize', makeLetters);
    return () => {
        window.removeEventListener('resize', makeLetters);
    };
  }, [makeLetters])

  useEffect(() => {
    makeLetters()
  }, [makeLetters])

  return (
    <div 
      onResize={e => handleOnMove(e)}
      ref={eRef}
      className={styles.container}
      onMouseMove={e => handleOnMove(e)}
      onTouchMove={e => handleOnMove(e.touches[0])}
      >
    {letters}
    </div>
  )

}

export default EvervaultBackground